import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";
import { Config } from "./Config.ts";
import { initializeMixpanel } from "./Common/Services/Mixpanel.ts";

initializeMixpanel();

Sentry.init({
  dsn: Config.SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  //  Capture 100% of the transactions
  tracesSampleRate: 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/api\.virtualmike\.ai/, /^https:\/\/api-dev\.virtualmike\.ai/],
  // Session Replay
  // This sets the sample rate at 10%.
  // You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysSessionSampleRate: 0.1,
   // If you're not already sampling the entire session,
   // change the sample rate to 100% when sampling sessions where errors occur.
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
